"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsClaimData = void 0;
const button_1 = require("client/components/material/button");
const text_field_1 = require("client/components/material/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const store_1 = require("../../store");
require("./app-settings-claim-data.less");
const select_1 = require("client/components/material/select");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/modules/users-list/store");
const store_5 = require("client/modules/users/store");
const modal_1 = require("client/components/modal");
const text_area_1 = require("client/components/material/text-area");
let AppSettingsClaimData = class AppSettingsClaimData extends React.Component {
    constructor() {
        super(...arguments);
        this.rxSearch = "";
        this.siteId = "";
        this.enableErxModal = false;
        this.erxInput = "";
        this.erxOutput = "";
        this.claimData = null;
        this.claimDataOriginal = null;
        this.handleSubmit = async () => {
            const asd = await store_1.appSettingsStore.updateClaimData(this.claimData);
            if (asd.success)
                this.claimDataOriginal = this.claimData;
        };
        this.handleTranslate = async () => {
            const output = await store_1.appSettingsStore.readErx(this.erxInput);
            if (!!output)
                this.erxOutput = output;
        };
        this.handleSearch = async () => {
            const result = await store_1.appSettingsStore.readClaimData(this.siteId, this.rxSearch);
            this.claimData = result;
            this.claimDataOriginal = result;
            await store_2.sitesDetailStore.loadPatientsLite({
                patientId: this.claimData.patientId,
                siteId: this.siteId
            });
            await store_2.sitesDetailStore.loadProvidersLite({
                providerId: this.claimData.providerId,
                siteId: this.siteId
            });
            await store_4.usersListStore.loadUsers();
        };
        this.renderErxModal = () => {
            if (!this.enableErxModal)
                return;
            const translateButton = (React.createElement(button_1.MaterialButton, { style: { marginRight: "1em" }, primary: true, onClick: this.handleTranslate }, "Translate"));
            const cancelButton = (React.createElement(button_1.MaterialButton, { onClick: () => { this.enableErxModal = false; } }, "Cancel"));
            const input = React.createElement(text_area_1.MaterialTextArea, { className: "erx__text-area", onChange: (e, v) => { this.erxInput = v; }, placeholder: "Paste your ERX payload string below.", value: this.erxInput });
            const output = React.createElement(text_area_1.MaterialTextArea, { className: "erx__text-area erx__text-area--output", value: this.erxOutput });
            const buttons = [translateButton, cancelButton];
            const modal = React.createElement(modal_1.Modal, { buttons: buttons, height: "fit-content", onCancel: () => { this.enableErxModal = false; }, overflowY: true, top: "25%", width: "fit-content" },
                input,
                output,
                React.createElement("button", { onClick: () => {
                        const txt = document.querySelector(".erx__text-area--output").firstChild;
                        console.log(txt);
                        txt.select();
                        document.execCommand("copy");
                    } }, "Copy to Clipboard"));
            return modal;
        };
    }
    async componentDidMount() {
        await store_3.sitesListStore.loadSitesNoRelation();
    }
    componentWillUnmount() { }
    get availableUsers() {
        var _a, _b;
        return ((_b = (_a = store_4.usersListStore.users) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : []).map((user, i) => ({
            id: i,
            label: `${user.prefix} ${user.firstName} ${user.lastName} ${user.suffix}`,
            value: user.id
        }));
    }
    get availableProviders() {
        var _a, _b;
        return ((_b = (_a = store_2.sitesDetailStore.providers) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : []).map((provider, i) => ({
            id: i,
            label: `${provider.prefix} ${provider.firstName} ${provider.lastName} ${provider.suffix}`,
            value: provider.id
        }));
    }
    get availablePatients() {
        var _a, _b;
        return ((_b = (_a = store_2.sitesDetailStore.patients) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : []).map((patient, i) => {
            const dob = patient.birthDate === "0000-00-00" ? "N/A" : patient.birthDate;
            return {
                id: i,
                label: `${patient.firstName} ${patient.lastName} (${dob || "N/A"})`,
                value: patient.id
            };
        });
    }
    get availableSites() {
        var _a;
        const options = [];
        const isImbUser = store_5.usersStore.user.value.user;
        if (isImbUser) {
            if (store_3.sitesListStore.sites.value) {
                store_3.sitesListStore.sites.value.forEach((site, i) => {
                    options.push({
                        id: i,
                        label: site.displayName || site.name,
                        value: site.id
                    });
                });
            }
        }
        else {
            const { site } = store_5.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id
            };
            options.push(siteOption);
        }
        return options;
    }
    renderSettings() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const head = React.createElement("h2", null, "Claim Data Management");
        console.log({ this: this });
        const search = (React.createElement("div", { style: {
                alignItems: "center",
                display: "flex",
                justifyContent: "space-around",
                margin: "2em auto 0",
                width: "80%"
            } },
            React.createElement(select_1.MaterialSelect, { options: this.availableSites, value: this.siteId, label: "Pharmacy", searchable: true, onSelect: e => {
                    this.siteId = e;
                } }),
            React.createElement(text_field_1.MaterialTextField, { value: this.rxSearch, label: "Rx Number", onChange: (e, v) => (this.rxSearch = v), style: { marginLeft: "1em" }, autoFocus: true }),
            React.createElement(button_1.MaterialButton, { disabled: !this.rxSearch.length, onClick: this.handleSearch, style: { marginLeft: "1em" }, primary: true }, "Search"),
            React.createElement(button_1.MaterialButton, { onClick: () => { this.enableErxModal = true; }, secondary: true, style: { marginLeft: "1em" } }, "ERX Translate")));
        const stuff = (React.createElement("div", { style: { display: "flex", flexDirection: "column", margin: "0 auto", maxWidth: "70%" } },
            React.createElement("div", { style: {
                    display: "flex",
                    justifyContent: "space-evenly",
                    margin: "1em 0"
                } },
                React.createElement("div", null,
                    React.createElement(select_1.MaterialSelect, { options: this.availablePatients, label: "Patient", searchable: true, value: ((_a = this.claimData) === null || _a === void 0 ? void 0 : _a.patientId) || ((_b = this.claimDataOriginal) === null || _b === void 0 ? void 0 : _b.patientId), onSelect: e => {
                            this.claimData.patientId = e;
                        } }),
                    React.createElement(select_1.MaterialSelect, { options: this.availableProviders, label: "Provider", searchable: true, value: ((_c = this.claimData) === null || _c === void 0 ? void 0 : _c.providerId) || ((_d = this.claimDataOriginal) === null || _d === void 0 ? void 0 : _d.providerId), onSelect: e => {
                            this.claimData.providerId = e;
                        } }),
                    React.createElement(select_1.MaterialSelect, { options: this.availableUsers, label: "User", searchable: true, value: ((_e = this.claimData) === null || _e === void 0 ? void 0 : _e.userId) || ((_f = this.claimDataOriginal) === null || _f === void 0 ? void 0 : _f.userId), onSelect: e => {
                            this.claimData.userId = e;
                        } })),
                React.createElement("div", { style: { display: "grid" } },
                    React.createElement(text_field_1.MaterialTextField, { value: ((_h = (_g = this.claimData) === null || _g === void 0 ? void 0 : _g.inventory) === null || _h === void 0 ? void 0 : _h.name) || "", label: "Name", onChange: (e, v) => {
                            this.claimData.inventory.name = v;
                        } }),
                    React.createElement(text_field_1.MaterialTextField, { value: ((_k = (_j = this.claimData) === null || _j === void 0 ? void 0 : _j.inventory) === null || _k === void 0 ? void 0 : _k.strengthDescription) || "", label: "Str Description", onChange: (e, v) => {
                            this.claimData.inventory.strengthDescription = v;
                        } }),
                    React.createElement(text_field_1.MaterialTextField, { value: ((_m = (_l = this.claimData) === null || _l === void 0 ? void 0 : _l.inventory) === null || _m === void 0 ? void 0 : _m.strengthDescriptionShort) || "", label: "Str Description Short", onChange: (e, v) => {
                            this.claimData.inventory.strengthDescriptionShort = v;
                        } }))),
            React.createElement(button_1.MaterialButton, { onClick: this.handleSubmit, disabled: JSON.stringify(this.claimData) ===
                    JSON.stringify(this.claimDataOriginal), primary: true, style: { width: "fit-content", left: "80%" } }, "Save")));
        const hasSearch = !!this.claimData;
        const hasResult = (_o = Object(this.claimData)) === null || _o === void 0 ? void 0 : _o.hasOwnProperty("id");
        const content = (React.createElement("div", { style: { padding: "0 10em 5em" } },
            head,
            search,
            hasResult ? (stuff) : hasSearch ? (React.createElement("p", { style: { textAlign: "center" } }, "Matching claim not found.")) : (React.createElement(React.Fragment, null))));
        return content;
    }
    render() {
        const didLoad = true;
        return (React.createElement("div", null,
            didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading."),
            this.renderErxModal()));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "rxSearch", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "enableErxModal", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "erxInput", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "erxOutput", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "claimData", void 0);
__decorate([
    mobx_1.observable
], AppSettingsClaimData.prototype, "claimDataOriginal", void 0);
__decorate([
    mobx_1.computed
], AppSettingsClaimData.prototype, "availableUsers", null);
__decorate([
    mobx_1.computed
], AppSettingsClaimData.prototype, "availableProviders", null);
__decorate([
    mobx_1.computed
], AppSettingsClaimData.prototype, "availablePatients", null);
__decorate([
    mobx_1.computed
], AppSettingsClaimData.prototype, "availableSites", null);
AppSettingsClaimData = __decorate([
    mobx_react_1.observer
], AppSettingsClaimData);
exports.AppSettingsClaimData = AppSettingsClaimData;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-claim-data/app-settings-claim-data.tsx
// module id = 3205
// module chunks = 0